import { render, staticRenderFns } from "./BnAddressBaleset.vue?vue&type=template&id=0da5f20c&"
import script from "./BnAddressBaleset.vue?vue&type=script&lang=js&"
export * from "./BnAddressBaleset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports